import { render, staticRenderFns } from "./_milestoneitem.vue?vue&type=template&id=a0f97854"
import script from "./_milestoneitem.vue?vue&type=script&lang=js"
export * from "./_milestoneitem.vue?vue&type=script&lang=js"
import style0 from "./_milestoneitem.vue?vue&type=style&index=0&id=a0f97854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports